/* eslint-disable import/prefer-default-export */

export const DATA_TABLE_EL_CHANGED = 'DATA_TABLE_EL_CHANGED';
export const TEXT_MESSAGE_CHANGED = 'TEXT_MESSAGE_CHANGED';
export const IS_SUBMITTING_CHANGED = 'IS_SUBMITTING_CHANGED';
export const ESTIMATED_NUMBER_OF_SENDS_CHANGED = 'ESTIMATED_NUMBER_OF_SENDS_CHANGED';
